import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
declare var window: any;

@Component({
	selector: "celine-widget-frame-container",
	template: require('./widget-frame.component.html'),
	styles: [
		`
		.message {
			position: fixed;
			top: 50%;
			left: 50%;
			transform: translate(-50%, -50%);
			-webkit-transform: translate(-50%, -50%);
			-moz-transform: translate(-50%, -50%);
			-o-transform: translate(-50%, -50%);
			-ms-transform: translate(-50%, -50%);
			z-index: 100;
		}

		.info {
			top: 0;
			left: 0;
			font-size: 17px;
			font-weight: 500;
		}
		`
	]
})

export class WidgetFrameComponent implements OnInit {
	public error: boolean = false;
	public loading: boolean = true;
	public connectedExperiences: any[];
	public connectedExperienceName: any;
	public widgetName: any;
	public widget: any;

	constructor(private activatedRoute: ActivatedRoute) {
		this.error = false;
		this.loading = true;
	}

	ngOnInit(): void {
		this.activatedRoute.queryParams.subscribe((params) => {
			this.connectedExperiences = window.__CELINE_exp;

			// get querystring
			this.connectedExperienceName = params["experienceName"];
			this.widgetName = params["widgetName"];

			if (this.connectedExperiences) {
				for (const experience of this.connectedExperiences) {
					if (experience.name === this.connectedExperienceName) {
						const indx = experience.widgets.findIndex((element) => {
							return element.componentId === this.widgetName;
						});
						this.widget = experience.widgets[indx];						
					}					
				}
				
				if (!this.widget) {
					this.error = true;
					this.loading = false;
				} else {
					this.error = false;
					this.loading = false;
				}
			}

			
		});
  }
}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./~/angular-router-loader/src!./src/app/celine/components/widget-frame/widget-frame.component.ts